import { render, staticRenderFns } from "./DialogAddNews.vue?vue&type=template&id=3e199cfe&scoped=true&"
import script from "./DialogAddNews.vue?vue&type=script&lang=js&"
export * from "./DialogAddNews.vue?vue&type=script&lang=js&"
import style0 from "./DialogAddNews.vue?vue&type=style&index=0&id=3e199cfe&lang=scss&scoped=true&"
import style1 from "./DialogAddNews.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e199cfe",
  null
  
)

export default component.exports